import { useFormikContext } from "formik";
import { CheckCircle2, AlertCircle } from "lucide-react";
import React from "react";

const DeliveryOptions = ({
  viewMode,
  setViewMode,
}: {
  viewMode: string;
  setViewMode: (v: string) => void;
}) => {
  const { values, setFieldValue } = useFormikContext<any>();
  const activeMode = values.deliveryOption;
  const isCurrentActive = viewMode === activeMode;

  const tabs = [
    { id: "fixed", label: "Fixed Rate" },
    { id: "manual", label: "Manual Calculation" },
  ];

  return (
    <div style={{ marginBottom: "25px" }}>
      {/* 1. Main Navigation Tabs */}
      <div
        style={{
          display: "flex",
          borderBottom: "1px solid #E2E8F0",
          marginBottom: "0",
        }}
      >
        {tabs.map((tab) => {
          const isActiveTab = viewMode === tab.id;
          return (
            <div
              key={tab.id}
              onClick={() => setViewMode(tab.id)}
              style={{
                padding: "12px 24px",
                cursor: "pointer",
                borderBottom: isActiveTab
                  ? "2px solid #EF4444"
                  : "2px solid transparent",
                color: isActiveTab ? "#EF4444" : "#64748B",
                fontWeight: isActiveTab ? 600 : 500,
                fontSize: "14px",
                transition: "all 0.2s",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {tab.label}
              {activeMode === tab.id && (
                <span
                  style={{
                    fontSize: "10px",
                    background: "#DCFCE7",
                    color: "#166534",
                    padding: "2px 6px",
                    borderRadius: "10px",
                  }}
                >
                  Active
                </span>
              )}
            </div>
          );
        })}
      </div>

      {/* 2. Contextual Action Bar */}
      <div
        style={{
          background: isCurrentActive ? "#F0FDF4" : "#F8FAFC",
          border: isCurrentActive ? "1px solid #BBF7D0" : "1px solid #E2E8F0",
          borderTop: "none",
          borderBottomLeftRadius: "8px",
          borderBottomRightRadius: "8px",
          padding: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {isCurrentActive ? (
            <CheckCircle2 size={20} color="#16A34A" />
          ) : (
            <AlertCircle size={20} color="#64748B" />
          )}
          <div>
            <div
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: isCurrentActive ? "#15803D" : "#334155",
              }}
            >
              {isCurrentActive
                ? `${tabs.find((t) => t.id === viewMode)?.label} is Active`
                : `Configure ${tabs.find((t) => t.id === viewMode)?.label}`}
            </div>
            <div
              style={{
                fontSize: "12px",
                color: isCurrentActive ? "#166534" : "#64748B",
              }}
            >
              {isCurrentActive
                ? "Customers will be charged according to these settings."
                : "This mode is currently inactive. Activate it to use these rates."}
            </div>
          </div>
        </div>

        {!isCurrentActive && (
          <button
            type="button"
            onClick={() => setFieldValue("deliveryOption", viewMode)}
            style={{
              padding: "8px 16px",
              background: "#FFF",
              border: "1px solid #E2E8F0",
              borderRadius: "6px",
              color: "#334155",
              fontSize: "13px",
              fontWeight: 600,
              cursor: "pointer",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <CheckCircle2 size={14} color="#334155" />
            Set as Active
          </button>
        )}
      </div>
    </div>
  );
};

export default DeliveryOptions;
